/* eslint-disable prettier/prettier */
import React from "react";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import reducers from "../reducer";
import ReduxThunk from "redux-thunk";
import { DomainProvider } from "../context/DomainContext";
import i18n from "../i18n/i18n";

const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
      })
    : compose;

const createReduxStore = () =>
  createStore(reducers, composeEnhancers(applyMiddleware(ReduxThunk)));

const isBrowser = typeof window !== "undefined";
let domain = process.env.GATSBY_DOMAIN;

if (isBrowser) {
  if (domain === "en") {
    i18n.changeLanguage("en");
  }
}

const ReduxWrapper = ({ element }) => (
  <Provider store={createReduxStore()}>
    <DomainProvider value={domain}>{element}</DomainProvider>
  </Provider>
);

export default ReduxWrapper;
